import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { LoaderComponent } from '../../../pages/loader/loader.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { ajaxservice } from '../../../../services/ajaxservice';
import { formatDate } from '@angular/common';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { ToastrService } from 'ngx-toastr'
import { ExcelService } from '../../../../services/excelservice';
import moment from 'moment';
import { NgbModal, NgbDate, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { HttpResponse } from '@angular/common/http';
import { assign } from 'lodash';
import { concatAll } from 'rxjs/operators';
import { C } from '@angular/cdk/keycodes';
import { title } from 'process';
import { TicketdetailsComponent } from '../../all-shared/ticketdetails/ticketdetails.component';
declare var $: any;

@Component({
  selector: 'kt-pms-profile-report',
  templateUrl: './pms-profile-report.component.html',
  styleUrls: ['./pms-profile-report.component.scss'],
  providers: [TicketdetailsComponent]
})
export class PmsProfileReportComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  cusCode: string;
  cusName: string;
  assetStatus: any[];
  customer_details: any[];
  customerid_settings:any={}
  dropdownFacilityDepartSettings:any={}
  facility_department: any;
  facility_depart_id: any=[];
  facilityDepartId: any=[];
  pmsFiltter:FormGroup;
  LoaderComponentPortal: ComponentPortal<LoaderComponent>;
  @ViewChild('dataTables', { static: true }) table;
  overlayRef: OverlayRef;
  error: string;
  showAssetHistory: boolean;
  pageLoader: boolean;
  assetStatusReportData: any[];
  currentPage1: number=1;
  totalRecords1: any;
  endRecord1: any;
  startRecord1: any;
  showFilters: boolean;
  search_value: string;
  searchError: string;
  selectedItemsPerPage1: number=50;
  defaultTo: any;
  defaultFrom: any;
  to: any;
  ticket_details: any;
  searchValue: string;
  showAllTicketTable: boolean;
  tableHeight: any;
  itemsPerPage1: any;
  from: any;
  return_draw: number;
  pagination_flag: boolean;
  duration_period: boolean=false;
  searchValue1: string;
  pmsDataList: any;
  showTable: boolean;
  errors: any;
  ticket_id: any;
  falg: any;
  pageFilter: any;
  public onDateRangeSelection(range: { from: Date, to: Date }) {
    this.from = range.from;
    this.to = range.to;
  }
constructor(private ajax: ajaxservice, private overlay: Overlay, private calendar: NgbCalendar, private toastr: ToastrService, private chRef: ChangeDetectorRef, 
    private excelservice: ExcelService,private modalService: NgbModal,private sanitizer: DomSanitizer,private fb: FormBuilder) { 
    this.pmsFiltter = new FormGroup({
      status_id:new FormControl([],Validators.required),
      customer_name:new FormControl('1',Validators.required),
      FacilityDepart:new FormControl('',Validators.required),
      selected_period:new FormControl(localStorage.getItem('durartion'),Validators.required),
    });
    this.defaultTo = new Date();
    this.defaultFrom = (new Date().getMonth() + 1) + '.' + '01' + '.' + (new Date().getFullYear());
    this.to = this.calendar.getToday();
  }
  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 150,
      lengthMenu:[50,100,150],
      language: {
            "zeroRecords": 'No Data Available'
          },
      scrollY: 400,                             //for individual scroll inside table // sowmiya //feb19-2025
      scrollX: true,
      };
    this.cusCode= localStorage.getItem('reg_cust_code')
    this.cusName= localStorage.getItem('reg_cust_name')
    this.getFacilityDepartment();
    this.assetStatus = [
      {'assetStatusId':'Functional Equipment','assetStatusValue':'Functional'},
      {'assetStatusId':'Non Functional Equipment','assetStatusValue':'Not-Functional'},
      {'assetStatusId':'BER','assetStatusValue':'BER'}
    ];
    this.customer_details = [
      {'customer_code':this.cusCode,'customer_name':this.cusName}
    ];
    this.pmsFiltter.controls['status_id'].setValue('1');
    this.pageFilter =localStorage.getItem('pageFilter');
    if(this.pageFilter==1){
		this.pmsFiltter.controls['status_id'].setValue('All');
    }else if(this.pageFilter==2){
		this.pmsFiltter.controls['status_id'].setValue('completed');
    }else{
		this.pmsFiltter.controls['status_id'].setValue('pending');
    }
    // this.LoaderComponentPortal = new ComponentPortal(LoaderComponent);
    // Facility Department settings
    this.customerid_settings = {
      singleSelection: false,
      idField: 'customer_code',
      textField: 'customer_name',
      selectAllText: 'Select Facility name',
      unSelectAllText: 'UnSelect Facility name',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    // Facility Department settings
    this.dropdownFacilityDepartSettings ={
      singleSelection: false,
      idField: 'device_class_id',
      textField: 'device_class',
      selectAllText: 'Select Facility Department',
      unSelectAllText: 'UnSelect Facility Department',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.defaultTo= localStorage.getItem('toDate');
			this.defaultFrom = localStorage.getItem('fromDate');
      this.to = this.defaultTo;
      this.from= this.defaultFrom;
			if((localStorage.getItem('durartion')!='MTD'&&localStorage.getItem('durartion')!='QTD'&&localStorage.getItem('durartion')!='YTD')){
			  this.duration_period = true;
			}
    setTimeout(() => {
      this.getPmsReport()
    },1000)
  }
   // single select AssetStatus functionality
   onItemSelectFacilityDepart(items: any) {
    (this.facility_department.length!=this.facility_depart_id.length)?this.facility_depart_id=this.facility_depart_id:this.facility_depart_id=[];
    this.facility_depart_id.push(items.device_class_id);
    this.facilityDepartId = this.facility_depart_id;
  }
  // allselect AssetStatus functionality
  onSelectAllFacilityDepart(items: any) {
    this.facility_depart_id = [];
    this.facility_depart_id =[];
    var isPresent = this.facility_depart_id.some(function (el) { return el === items.device_class_id });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.facility_depart_id.push(value.device_class_id);
      })
    };
    this.facilityDepartId = this.facility_depart_id;
  }
  // single deselect AssetStatus functionality
  onItemDeSelectFacilityDepart(items: any) {
    const index: number = this.facility_depart_id.indexOf(items.device_class_id);
    if (index !== -1) {
      this.facility_depart_id.splice(index, 1);
    }
    this.facilityDepartId = this.facility_depart_id;
  }
  // all deselect AssetStatus functionality
  onItemDeSelectAllFacilityDepart(items: any) {
    this.facilityDepartId = [];
    this.facility_depart_id =[];
  }
  // Facility Department
  getFacilityDepartment() {
    var url = 'get_faciility_department/';
    this.ajax.getdata(url).subscribe((result) => {
      if(result.response.response_code == '200' || result.response.response_code == '400') {
        this.facility_department = result.response.data;
        this.facility_department.filter(facilityDepartment=>{this.facilityDepartId.push(facilityDepartment.device_class_id)})
      } else if (result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error');
      } else {
        this.toastr.error("Something went wrong", 'Error');
      }
    }, (err) => {
      console.log(err);                                             //prints if it encounters an error
    });
  }

  // period change
onChangePeriod(value){
  console.log(this.defaultFrom,this.defaultTo,"427")
  if(value == ''){
    this.duration_period = true;
  }
  else{
    this.duration_period = false;
  }
}
getPmsReport(){
  // this.overlayRef.attach(this.LoaderComponentPortal);
  this.pmsFiltter.controls['customer_name'].setValue('1');
  this.showTable = false;
  this.from = moment(this.from).format('YYYY-MM-DD');
  this.to = moment(this.to).format('YYYY-MM-DD');
  // if(this.pagelink!='' && this.pagelink!=null){
  //   this.showFilters = false;
  //   this.stateId =(localStorage.getItem('AssetState')!='')?localStorage.getItem('AssetState').split(',').map(Number):[]
  //   this.districtId=(localStorage.getItem('AssetDistrict')!='')?localStorage.getItem('AssetDistrict').split(',').map(Number):[]
  //   this.customer_code =(localStorage.getItem('AssetFacilityName')!='')?localStorage.getItem('AssetFacilityName').split(','):[]
  //   this.facilityNatureId =(localStorage.getItem('AssetFacilityNature')!='')?localStorage.getItem('AssetFacilityNature').split(',').map(Number):[]
  //   this.facilityDepartId =(localStorage.getItem('AssetFacilityDepart')!='')?localStorage.getItem('AssetFacilityDepart').split(',').map(Number):[]
  //   this.facilityTypeId = (localStorage.getItem('AssetFacilityType')!='')?localStorage.getItem('AssetFacilityType').split(',').map(Number):[]
  //   this.productId =(localStorage.getItem('AssetProduct')!='')?localStorage.getItem('AssetProduct').split(',').map(Number):[]
  //   this.contractId =(localStorage.getItem('AssetContract')!='')?localStorage.getItem('AssetContract').split(',').map(Number):[]
  //   this.equipmentNameId =(localStorage.getItem('AssetEquipment')!='')?localStorage.getItem('AssetEquipment').split(','):[]
  //   this.pms_status = (localStorage.getItem('PageFilter')=='1')?[]:(localStorage.getItem('PageFilter')=='2')?"completed":"pending";
  //   this.from =localStorage.getItem('fromDate')
  //   this.to =localStorage.getItem('todate');
  //   const filteredProducts = this.products.filter(product => this.productId.includes(product.product_id));
  //   const filteredequipments= this.equipmentName.filter(equipname=>this.equipmentNameId.includes(equipname.name));
  //   this.pmsFiltter.controls['product_id'].setValue(filteredProducts);
  //   this.pmsFiltter.controls['equipment_name'].setValue(filteredequipments);
  //   localStorage.setItem('link','');
  //   this.pagelink ='';
  //   this.showFilters = true;
  // }
  // this.from = moment(this.from).format('YYYY-MM-DD');
  // this.to = moment(this.to).format('YYYY-MM-DD');
  this.showFilters = true;
  this.pageFilter ='';
  var data={
        "pms_status":this.pmsFiltter.value.status_id,
        "facility_department": this.facilityDepartId,
        "duration":this.pmsFiltter.value.selected_period,
        "from_date":(this.pmsFiltter.value.selected_period!="")?"":this.from,
        "to_date":(this.pmsFiltter.value.selected_period!="")?"":this.to,
        "customer_code":[this.cusCode]
    }
  var url='facility_pmsreport/'
  this.ajax.postdata(url, data).subscribe((result) => {        //added cus type ,productid location id sowmiya
    if (result.response.response_code == "200" || result.response.response_code == "400") {
      this.pmsDataList = result.response.data
      this.showTable = true;
      // this.overlayRef.detach();
      this.chRef.detectChanges();
    }
    else if (result.response.response_code == "500") {
      this.errors = result.response.message;
      // this.overlayRef.detach();
      this.chRef.detectChanges();
    }
    else {
      this.errors = "Something Went Wrong";
      // this.overlayRef.detach();
      this.chRef.detectChanges();
    }
  }, (err) => {
    console.log(err);                                                 //prints if it encounters an error
    // this.overlayRef.detach();
  });
}
reset(){
  this.showTable = false;
  this.pmsFiltter.reset();
  this.from = this.defaultFrom;
  let date: Date = new Date(this.defaultFrom);
  this.defaultFrom = date;
  this.defaultTo = new Date();
  this.to = this.defaultTo;
  this.facilityDepartId = [];
  this.pmsFiltter.controls['selected_period'].setValue('MTD');
  // this.pmsFiltter.controls['customer_name'].setValue('1');
  setTimeout(() => {
    this.getPmsReport();
  },1000)
  this.overlayRef.detach();
}
// ticket details based on TicketId 
get_ticket_details(tickt_id) {
  this.ticket_id = tickt_id
  const modalRef: NgbModalRef = this.modalService.open(TicketdetailsComponent, {
    size: 'lg', //specifies the size of the dialog box
    windowClass: "center-modalcontract",
    backdrop: 'static',              //popup outside click by Sowndarya
    keyboard: false
  });
  modalRef.componentInstance.ticket_id = this.ticket_id;
  modalRef.componentInstance.falg = this.falg
}
// export PMS ticket details
exportAsPmsStatusReport(): void {
  const newArr = this.pmsDataList.map(({ ticket_age_color, ...rest }) => rest); // Removes 'name' from all objects
  setTimeout(() => {
    this.excelservice.exportAsExcelFile(newArr, 'pms_report');
  }, 1000);
}
}
